import { createBigDecimal, plus } from '@0xtorch/big-decimal'
import type { AssetBalance } from '../types/assetBalance'

type CreateAssetBalancesForWacbParameters = {
  readonly assetBalances: Map<string, readonly AssetBalance[]>
  readonly usedBalances: Map<string, AssetBalance>
}

export const createAssetBalancesForWacb = ({
  assetBalances,
  usedBalances,
}: CreateAssetBalancesForWacbParameters): Map<string, AssetBalance> => {
  const wacbAssetBalances = new Map<string, AssetBalance>()
  for (const [assetId, balances] of assetBalances) {
    const balance = wacbAssetBalances.get(assetId) ?? {
      amount: createBigDecimal(0n),
      value: createBigDecimal(0n),
    }
    for (const { amount, value } of balances) {
      balance.amount = plus(balance.amount, amount)
      balance.value = plus(balance.value, value)
    }
    wacbAssetBalances.set(assetId, balance)
  }
  for (const [assetId, balance] of usedBalances) {
    const wacbBalance = wacbAssetBalances.get(assetId) ?? {
      amount: createBigDecimal(0n),
      value: createBigDecimal(0n),
    }
    wacbBalance.amount = plus(wacbBalance.amount, balance.amount)
    wacbBalance.value = plus(wacbBalance.value, balance.value)
    wacbAssetBalances.set(assetId, wacbBalance)
  }
  return wacbAssetBalances
}
